// Zara-Style Multi-Step Wizard JavaScript
// Hybrid Logic: Wizard UI + Metafield Data

// State
let currentStep = 1;
const totalSteps = 4;
const userData = {
    gender: '',
    height: 170,
    weight: 70,
    bodyType: '',
    fitPreference: 'regular'
};

// DOM Elements
let modalOverlay, openModalBtn, closeModalBtn, stepsContainer, progressFill, backBtn;

// Initialize
document.addEventListener('DOMContentLoaded', init);

function init() {
    // 1. Get Elements
    modalOverlay = document.getElementById('modalOverlay');
    openModalBtn = document.getElementById('openModal');
    closeModalBtn = document.getElementById('closeModal');
    stepsContainer = document.getElementById('stepsContainer');
    progressFill = document.getElementById('progressFill');
    backBtn = document.getElementById('backBtn');

    // Safety check for data
    if (!window.ZARA_SIZE_DATA) {
        if (openModalBtn) openModalBtn.style.display = 'none';
        return;
    }

    // 2. Modal Controls
    if (openModalBtn) openModalBtn.addEventListener('click', openModal);
    if (closeModalBtn) closeModalBtn.addEventListener('click', closeModal);
    if (modalOverlay) modalOverlay.addEventListener('click', (e) => {
        if (e.target === modalOverlay) closeModal();
    });

    // 3. Step 1: Gender selection
    document.querySelectorAll('[data-step="1"] .option-card').forEach(card => {
        card.addEventListener('click', () => {
            userData.gender = card.dataset.value;
            selectOption(card);
            setTimeout(() => nextStep(), 300);
        });
    });

    // 4. Step 2: Height & Weight Sliders
    const heightSlider = document.getElementById('heightSlider');
    const weightSlider = document.getElementById('weightSlider');
    const heightValue = document.getElementById('heightValue');
    const weightValue = document.getElementById('weightValue');
    const measurementsContinue = document.getElementById('measurementsContinue');

    if (heightSlider) {
        heightSlider.addEventListener('input', (e) => {
            if (heightValue) heightValue.textContent = e.target.value;
            userData.height = parseFloat(e.target.value);
        });
    }

    if (weightSlider) {
        weightSlider.addEventListener('input', (e) => {
            if (weightValue) weightValue.textContent = e.target.value;
            userData.weight = parseFloat(e.target.value);
        });
    }

    if (measurementsContinue) {
        measurementsContinue.addEventListener('click', () => {
            nextStep();
        });
    }

    // 5. Step 3: Body Type
    document.querySelectorAll('[data-step="3"] .option-card').forEach(card => {
        card.addEventListener('click', () => {
            userData.bodyType = card.dataset.value;
            selectOption(card);
            setTimeout(() => {
                nextStep();
                calculateSize();
            }, 300);
        });
    });

    // 7. Navigation
    if (backBtn) backBtn.addEventListener('click', prevStep);

    // 8. Results Actions
    const recalcBtn = document.getElementById('recalculateBtn');
    if (recalcBtn) recalcBtn.addEventListener('click', resetWizard);

    // Display Result Only - Button just closes modal
    const closeWizardBtn = document.getElementById('closeWizardBtn');
    if (closeWizardBtn) closeWizardBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        closeModal();
    });
}

// Modal Functions
function openModal() {
    modalOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
    updateProgress();
}

function closeModal() {
    modalOverlay.classList.remove('active');
    document.body.style.overflow = '';
    setTimeout(resetWizard, 300);
}

// Navigation
function nextStep() {
    if (currentStep < totalSteps) {
        const currentStepEl = document.querySelector(`[data-step="${currentStep}"]`);
        const nextStepEl = document.querySelector(`[data-step="${currentStep + 1}"]`);

        currentStepEl.classList.remove('active');
        currentStepEl.classList.add('prev');

        nextStepEl.classList.add('active');
        nextStepEl.classList.remove('prev');

        currentStep++;
        updateProgress();
        updateBackButton();

        // Scroll to top of modal container
        const container = document.querySelector('.zara-modal-container');
        if (container) container.scrollTop = 0;
    }
}

function prevStep() {
    if (currentStep > 1) {
        const currentStepEl = document.querySelector(`[data-step="${currentStep}"]`);
        const prevStepEl = document.querySelector(`[data-step="${currentStep - 1}"]`);

        currentStepEl.classList.remove('active');

        prevStepEl.classList.remove('prev');
        prevStepEl.classList.add('active');

        currentStep--;
        updateProgress();
        updateBackButton();

        // Scroll to top of modal container
        const container = document.querySelector('.zara-modal-container');
        if (container) container.scrollTop = 0;
    }
}

function updateProgress() {
    const progress = ((currentStep - 1) / (totalSteps - 1)) * 100;
    if (progressFill) progressFill.style.width = `${progress}%`;

    const stepNumEl = document.getElementById('currentStepNum');
    if (stepNumEl) stepNumEl.textContent = currentStep;
}

function updateBackButton() {
    if (!backBtn) return;
    // Show back button on all steps except the first one
    if (currentStep > 1) {
        backBtn.disabled = false;
        backBtn.style.display = 'flex';
    } else {
        backBtn.disabled = true;
        backBtn.style.display = 'none';
    }
}

function selectOption(card) {
    const siblings = card.parentElement.querySelectorAll('.option-card');
    siblings.forEach(s => s.classList.remove('selected'));
    card.classList.add('selected');
}

function resetWizard() {
    currentStep = 1;
    // Keep user data or reset? Let's reset for fresh start
    // userData.gender = ''; // Optional

    document.querySelectorAll('.step').forEach((step, index) => {
        step.classList.remove('active', 'prev');
        if (index === 0) step.classList.add('active');
    });

    document.querySelectorAll('.option-card').forEach(card => {
        card.classList.remove('selected');
    });

    updateProgress();
    updateBackButton();
}

// ------------------------------------------------------------------
// ALGORITHM (Simplified & Hybrid)
// ------------------------------------------------------------------
function calculateSize() {
    const { gender, height, weight, bodyType, fitPreference } = userData;
    const sizeData = window.ZARA_SIZE_DATA;

    if (!sizeData) return;

    // 1. Choose the Chart
    // Use 'men' key if it exists, otherwise use the root object
    let chart = sizeData.men || sizeData;

    // Safety check: if chart has a 'men' key inside (doubly nested), go deeper
    if (chart.men) chart = chart.men;

    // 2. Estimate Chest (Base estimation from Height/Weight/Gender)
    let estimatedChest = estimateChestBase(height, weight, gender);

    // 3. Adjust for Body Type
    if (bodyType === 'slim') estimatedChest *= 0.95;
    if (bodyType === 'broad' || bodyType === 'athletic') estimatedChest *= 1.05;

    // 4. Adjust for Fit Preference
    if (fitPreference === 'slim') estimatedChest -= 2;
    if (fitPreference === 'relaxed') estimatedChest += 2;
    if (fitPreference === 'oversized') estimatedChest += 4;

    // 5. Lookup Best Fit (in Men's terms)
    let bestSizeLabel = null;
    let minDiff = Infinity;
    const availableSizes = Object.keys(chart).filter(k => typeof chart[k] === 'object');

    availableSizes.forEach(sizeLabel => {
        const measurements = chart[sizeLabel];
        let chartChest = measurements.chest || measurements.minChest || 0;

        // Handle range if present "36-38" or just single number
        if (typeof chartChest === 'string' && chartChest.includes('-')) {
            chartChest = parseFloat(chartChest.split('-')[1]); // Use max of range
        }

        let diff = Math.abs(estimatedChest - chartChest);
        if (diff < minDiff) {
            minDiff = diff;
            bestSizeLabel = sizeLabel;
        }
    });

    // 6. GENDER SHIFT (The Magic)
    // If user is women, we suggest ONE SIZE SMALLER than the men's result
    let finalSize = bestSizeLabel;
    if (gender === 'women') {
        const index = availableSizes.indexOf(bestSizeLabel);
        if (index > 0) {
            finalSize = availableSizes[index - 1]; // Shift down (e.g. L -> M)
        }
    }

    if (finalSize) {
        displayResults(finalSize, gender, bodyType, fitPreference);
    } else {
        // Fallback
        displayResults(availableSizes[Math.floor(availableSizes.length / 2)] || "M", gender, bodyType, fitPreference);
    }
}

function estimateChestBase(h, w, gender) {
    const h_m = h / 100;
    const bmi = w / (h_m * h_m);

    // Standard Ratios
    let ratio = (gender === 'women') ? 0.52 : 0.545;

    // BMI adjustments
    if (bmi < 18.5) ratio -= 0.03;
    if (bmi > 25) ratio += 0.03;
    if (bmi > 30) ratio += 0.05;

    const chestCm = h * ratio;
    return chestCm / 2.54; // to inches
}

function displayResults(size, gender, bodyType, fitPreference) {
    const resultSizeEl = document.getElementById('resultSize');
    if (resultSizeEl) resultSizeEl.textContent = size;

    const addSizeTextEl = document.getElementById('addSizeText');
    if (addSizeTextEl) addSizeTextEl.textContent = size;

    // Labels
    const genderEl = document.getElementById('resultGender');
    if (genderEl) genderEl.textContent = gender.toUpperCase();

    const bodyEl = document.getElementById('resultBodyType');
    if (bodyEl) bodyEl.textContent = bodyType.toUpperCase();

    // Alternatives
    generateAlternativeSizes(size, gender);
}

function generateAlternativeSizes(currentSize, gender) {
    const sizeData = window.ZARA_SIZE_DATA;
    // Robust chart lookup (Same as calculateSize)
    let chart = sizeData;
    if (sizeData[gender]) {
        chart = sizeData[gender];
    } else if (sizeData['men'] || sizeData['women']) {
        chart = sizeData['men'] || Object.values(sizeData)[0];
    }
    const sizes = Object.keys(chart);
    const currentIndex = sizes.indexOf(currentSize);

    const altSizesList = document.getElementById('altSizes');
    if (altSizesList) {
        altSizesList.innerHTML = '';

        const alternatives = [];
        if (currentIndex > 0) alternatives.push(sizes[currentIndex - 1]);
        if (currentIndex < sizes.length - 1) alternatives.push(sizes[currentIndex + 1]);

        alternatives.forEach(size => {
            const sizeEl = document.createElement('div');
            sizeEl.className = 'alt-size';
            sizeEl.textContent = size;
            sizeEl.addEventListener('click', () => {
                document.getElementById('resultSize').textContent = size;
                document.getElementById('addSizeText').textContent = size;
            });
            altSizesList.appendChild(sizeEl);
        });
    }
}


